import Vue from 'vue'
import state from 'lib/appState'
import animateScrollTo from 'animated-scroll-to'
import select from 'dom-select'
import { formatPrice, set, unset } from 'lib/util'
import bus from 'lib/bus'

export default el => new Vue({
  el,
  data () {
    return {
      state,
      busy: false
    }
  },
  computed: {
    activeVariant () {
      return this.state.activeVariant
    },
    productInfo () {
      const { Flavor, Quantity } = state.selectedOptions
      if (Flavor && Quantity) {
        return `${Quantity} of ${Flavor}`
      }
    },
    currentPrice () {
      if (!this.activeVariant) {
        return
      }

      if (this.hasSubscriptionOption && this.subscriptionSelected && this.subscriptionData) {
        return `$${formatPrice(this.activeSubscriptionPrice, 2)}`
      }

      return `$${formatPrice(this.activeVariant.price, 2)}`
    },
    submitButtonText () {
      if (!this.activeVariant) {
        return
      }

      if (this.activeVariant.available) {
        return 'Add to Cart'
      } else {
        return 'Sold out Join The Waitlist'
      }
    }
  },
  watch: {
    'state.showATCSticky' (value) {
      const FIXED_CLASS = 'product-sticky-nav-fixed'
      if (value) {
        set(document.body, FIXED_CLASS)
      } else {
        unset(document.body, FIXED_CLASS)
      }
    }
  },
  mounted () {
    bus.$on('product-form/ADDDED_TO_CART', () => {
      this.busy = false
    })
  },
  methods: {
    handleClick () {
      animateScrollTo(select('[data-product-form]'), {
        cancelOnUserAction: false,
        offset: select('#header').offsetHeight * -1
      })
    },
    addToCart () {
      this.busy = true
      bus.$emit('product-sticky-nav/ADD_TO_CART', { product: this.activeVariant })
    }
  }
})
